import React from 'react';

import Modal from '../Global/Modal';
import Button from '../Global/Button';

import emailIcon from '../../assets/icons/email-ticked.svg';

const RegistrationModal = ({ setModalOpened, open}) => {
    return (
        <Modal setModalOpened={() => { setModalOpened(false) }} open={open} >    
            <div className="modal__body">
                <div className="registration-modal">
                    <img src={emailIcon} alt="email-sent" className="registration-modal__image" />
                    <h2 className="registration-modal__title">
                        Uspješno ste nam poslali upit! Očekujte odgovor ubrzo!
                    </h2>
                    <p className="registration-modal__paragraph">
                        Hvala vam što ste nas kontaktirali, odgovoriti ćemo vam ubrzo. Očekujte odgovor na email adresu <br/>
                        koju ste upisali u formi.
                    </p>
                    <Button onClick={() => { setModalOpened(false) }} text="Ok" color="yellow-dark" classes="registration-modal__button" />
                </div>
            </div>
        </Modal>
    );
}

export default RegistrationModal;